export default __webpack_public_path__ + "static/media/masterdata.4637de9d.svg";